import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = (color: string) => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    color,
    fontFamily: theme.value.typography.fontFamily,
    '&--h1': {
      fontSize: '3.25rem',
      linehHeight: '3.75rem',
    },
    '&--h2': {
      fontSize: '3rem',
      lineHeight: '3.5rem',
    },
    '&--h3': {
      fontSize: '2.5rem',
      lineHeight: '3rem',
    },
    '&--h4': {
      fontSize: '2rem',
      lineHeight: '2.5rem',
    },
    '&--s1': {
      fontSize: '1.75rem',
      lineHeight: '2.25rem',
    },
    '&--s2': {
      fontSize: '1.5rem',
      lineHeight: '2rem',
    },
    '&--s3': {
      fontSize: '1.125rem',
      lineHeight: '1.625rem',
    },
    '&--s4': {
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    '&--b0': {
      fontSize: '1.25rem',
      lineHeight: '1.625rem',
    },
    '&--b1': {
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
    },
    '&--b2': {
      fontSize: '1rem',
      lineHeight: '1.375rem',
    },
    '&--b3': {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
    },
    '&--b4': {
      fontSize: '0.75rem',
      lineHeight: '1.125rem',
    },
    '&--b5': {
      fontSize: '0.625rem',
      lineHeight: '1rem',
    },
    '&--b6': {
      fontSize: '0.5rem',
      lineHeight: '0.875rem',
    },
    '&--bold': {
      fontWeight: theme.value.typography.fontWeight.bold,
    },

    '&--semibold': {
      fontWeight: theme.value.typography.fontWeight.semibold,
    },
    '&--medium': {
      fontWeight: theme.value.typography.fontWeight.medium,
    },

    '&--regular': {
      fontWeight: theme.value.typography.fontWeight.regular,
    },
    '&--normal': {
      fontStyle: 'normal',
    },
    '&--italic': {
      fontStyle: 'italic',
    },
  }));

  return baseClass;
};
